import {Component, Input, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-gather-header',
    templateUrl: './gather-header.component.html',
    styleUrls: ['./gather-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GatherHeaderComponent implements OnDestroy {
  @Input() headerText: String

  private subscriptions = new Subscription();

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
